<template>
	<div class="con">
		<div class="head">
			<div>住院清单</div>
			<div class="head-price"><span>￥</span>{{total}}</div>
		</div>
		<div class="list" >
			<div class="list-con" v-for="(item, index) in list" @click="indexBtn(index)">
				<div>
					<div class="list-con-top">
						<div class="list-text-left">
							<div class="classify">{{item.XMLB}}</div>
						</div>
						<div class="list-text-right">
							<div class="price">
								<div><span>￥</span>{{item.totalprice}}</div>
							</div>
							<div v-show="item.showState"><van-icon name="arrow-down" color="#999" size="18"/></div>
							<div v-show="!item.showState"><van-icon name="arrow" color="#999" size="18"/></div>
						</div>
					</div>
				</div>
				<div class="hide-show" v-show="item.showState">
					<div v-for="cell in item.d" class="list-hide-show">
						<div class="hide-show-left">{{cell.FYMC}}</div>
						<div class="hide-show-right">
							<div class="hide-show-price"><span>￥</span>{{cell.ZJJE}}</div>
							<div class="hide-show-num">x{{cell.FYSL}}</div>
							
						</div>
					</div>
				</div>
			</div>
			<div class="noImg" v-if="noImgShow == true">
				<img src="../assets/404.gif"/>
				<div class="no-text">无清单~~</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'inpatientDeta',
		data() {
			return {
				msg: '住院清单',
				list: [],
				total: 0,
				noImgShow: false,
				cardUserInfo: JSON.parse(localStorage.getItem('cardUserInfo')),
			}
		},
		methods: {
			//获取住院明细清单信息
			inpatientDetail(e) {
				this.$store.commit('Load', true)
				this.$Axios.Get('/inpatient/inpatientDetail?zyh=' + e, null).then(data => {
					this.$store.commit('Load', false)
					console.log(data)
					if(data.code == 0) {
						var listData = data.msg;
						if(listData.length != 0) {
							let newArr = JSON.parse(JSON.stringify(listData))
							
							for (let i = 0; i < newArr.length; i++) {
								newArr[i].showState = false;
								for (let j = i + 1; j < newArr.length;) {
							
									if (newArr[i].XMLB == newArr[j].XMLB) {
										newArr.splice(j, 1)
									} else {
										j++;
									}
								}
							}
							let total = 0;
							for (let j = 0; j < listData.length; j++) {
								total += listData[j].ZJJE;
							}
							for (let i = 0; i < newArr.length; i++) {
								let s = [];
								let dn = 0;//数量
								let dprice = 0;
								for (let j = 0; j < listData.length; j++) {
									if(newArr[i].XMLB == listData[j].XMLB){
										s.push(listData[j]);
										dn += listData[j].FYSL;
										dprice += listData[j].ZJJE;
									}
								}
								newArr[i].num = dn;
								newArr[i].totalprice = dprice.toFixed(2);
								newArr[i].d = s;
								
							}
							console.log(newArr)
							this.total = total.toFixed(2)
							this.list = newArr;
							this.noImgShow = false;
							
						} else {
							this.noImgShow = true;
						}

					} else {
						this.noImgShow = true;
					}

				}).catch(err => {
					this.$toast("网络未连接")
					this.$store.commit('Load', false)
					this.noImgShow = true;
					console.log(err)
				})
			},
			//去除浮点数
			toDecimal(x) {
				let val = Number(x)
				if(!isNaN(parseFloat(val))) {
					val = val.toFixed(2);
				}
				return val;
			},
			indexBtn(e){
				this.list[e].showState = !this.list[e].showState
				this.$set(this.list, e, this.list[e])
			},
			
			
		},
		mounted() {
			console.log(this.$route.query.id)
			this.inpatientDetail(this.$route.query.id);
		}
	}
</script>

<style scoped>
	.noImg {
		margin-top: 10vh;
		text-align: center;
	}
	
	.no-text {
		margin-top: 10px;
		color: #27BEC4;
		font-size: 16px;
	}
	
	.head {
		display: flex;
		justify-content: space-between;
		padding: 20px 10px;
		background: #27BEC4;
		color: #fff;
		font-size: 15px;
	}
	.head-price{
		color: #FF0000;
		font-size: 20px;
		font-weight: 700;
	}
	.head-price span{
		font-size: 14px;
		font-weight: 500;
	}
	
	.con {
		display: flex;
		flex-direction: column;
		flex-wrap: nowrap;
		width: 100%;
		height: 100%;
	}
	
	.list{
		flex: 1;
		overflow-y: auto;
	}
	
	.list-con{
		padding: 10px;
		margin: 5px auto;
		font-size: 15px;
		border: 1px solid #ccc;
		border-radius: 10px;
		width: 90%;
		background-color: #fff;
	}
	.classify{
		font-size: 18px;
		font-weight: 700;
	}
	.list-con-top{
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
	.list-text-left{
		width: 50%;
		 white-space: normal;
		    display: -webkit-box;
		    -webkit-box-orient: vertical;
		    -webkit-line-clamp: 2;	/*控制文字行数*/
	}
	.list-text-right{
		display: flex;
		align-items: center;
	}
	.list-total-num{
		font-size: 16px;
		text-align: end;
	}
	.time-disp{
		display: flex;
		align-items: center;
		margin-top: 5px;
		color: #999;
	}
	.time-text{
		margin-left: 10px;
	}
	.price{
		display: flex;
		align-items: center;
		color:#FF0000;
		font-size: 18px;
	}
	.price span{
		font-size: 12px;
	}
	.lower-content {
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin-bottom: 10px;
		font-size: 14px;
	}
	
	.lower-left {
		width: 80%;
	}
	
	.num-text {
		font-size: 13px;
	}
	
	.fade-enter-active,
	.fade-leave-active {
		transition: opacity .5s;
	}
	
	.fade-enter,
	.fade-leave-to
	/* .fade-leave-active below version 2.1.8 */
	
	{
		opacity: 0;
	}
	
	.total {
		display: flex;
		font-size: 15px;
	}
	
	.total div {
		padding: 10px 0;
		width: 50%;
		text-align: center;
	}
	
	.combined {
		background-color: #fff;
	}
	
	.combined span {
		color: #FF0000;
		font-size: 18px;
	}
	
	.pay-btn {
		background-color: #27BEC4;
		color: #fff;
	}
	.hide-show{
		margin-top: 10px;
		
	}
	.list-hide-show{
		margin: 5px;
		display: flex;
		justify-content: space-between;
	}
	.hide-show-left{
		width: 75%;
	}
	.hide-show-price{
		color: #FF0000;
	}
	.hide-show-num{
		text-align: end;
	}
</style>